// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__2DfHI","signatureButtonsRight":"ModalSign_signatureButtonsRight__16cgn"};